import { useResponseEditor } from '@graphiql/react';
import React from 'react';
export function ResultViewer(props) {
    var ref = useResponseEditor(props);
    return (React.createElement("section", { className: "result-window", "aria-label": "Result Window", "aria-live": "polite", "aria-atomic": "true", ref: ref }));
}
//# sourceMappingURL=ResultViewer.js.map